// Colour palette (AWS: squid-ink navy + orange, chosen 2026-10-22 from five options). It drives (1) the MUI theme and (2) CSS
// variables used by gradients, glows and the sidebar. More palettes can be added to PALETTES and selected via DEFAULT_PALETTE.
export const DEFAULT_PALETTE = 'aws';

const grad = (a, b, deg = 135) => `linear-gradient(${deg}deg, ${a}, ${b})`;

export const PALETTES = {
  aws: {
    label: 'AWS', swatch: ['#232f3e', '#ec7211', '#00a1c9'],
    primary: { main: '#ec7211', dark: '#c2410c', light: '#ff9900', contrastText: '#16191f', rgb: '236 114 17' },
    darkPrimary: { main: '#ff9900', dark: '#ec7211', light: '#ffb84d', contrastText: '#16191f', rgb: '255 153 0' },
    secondary: '#00a1c9',
    button: ['#ff9900', '#ec7211'],
    brand: ['#ff9900', '#ec7211', '#d13212'], hero: ['#161e2d', '#232f3e', '#31465f', '#0073bb'],
    g: [['#00a1c9', '#0073bb'], ['#1d8102', '#4aa31a'], ['#ff9900', '#d13212'], ['#545b64', '#232f3e']],
    sidebar: ['#0f1722', '#161e2d', '#232f3e'], glow: ['rgba(255,153,0,0.20)', 'rgba(0,161,201,0.22)'],
    auth: ['#0b121b', '#161e2d', '#232f3e'], authBlobs: ['rgba(255,153,0,0.30)', 'rgba(209,50,18,0.22)', 'rgba(0,161,201,0.30)'],
    nav: ['#ff9900', '#ffb84d', '#00a1c9', '#ff6b4a', '#6cc04a', '#40d1d6'], bar: ['#ff9900', '#ec7211', '#00a1c9', '#1d8102'],
    chart: ['#ec7211', '#00a1c9', '#1d8102', '#d13212', '#545b64', '#8b5cf6'], onPrimary: '#16191f',
  },
};

export const paletteOf = (name) => PALETTES[name] || PALETTES[DEFAULT_PALETTE];

// Writes the palette into CSS custom properties (read by gradients, glows, the sidebar and the login screen).
export function applyPaletteVars(p, mode = 'light') {
  const root = document.documentElement.style;
  const pr = mode === 'dark' ? p.darkPrimary : p.primary;
  const set = (k, v) => root.setProperty(k, v);
  set('--c-primary', pr.main); set('--c-primary-light', pr.light); set('--c-primary-rgb', pr.rgb);
  set('--btn-text', p.onPrimary);
  set('--btn-grad', grad(p.button[0], p.button[1])); set('--btn-grad-hover', grad(p.button[1], p.button[0]));
  set('--g-brand', `linear-gradient(135deg, ${p.brand[0]} 0%, ${p.brand[1]} 55%, ${p.brand[2]} 100%)`);
  set('--g-hero', `linear-gradient(120deg, ${p.hero.map((c, i) => `${c} ${Math.round(i * 100 / (p.hero.length - 1))}%`).join(', ')})`);
  ['sky', 'emerald', 'amber', 'violet'].forEach((k, i) => set(`--g-${k}`, grad(p.g[i][0], p.g[i][1])));
  set('--sb-bg', `linear-gradient(185deg, ${p.sidebar[0]} 0%, ${p.sidebar[1]} 50%, ${p.sidebar[2]} 100%)`);
  set('--sb-glow-1', `radial-gradient(circle, ${p.glow[0]}, transparent 70%)`); set('--sb-glow-2', `radial-gradient(circle, ${p.glow[1]}, transparent 70%)`);
  set('--sb-active', `linear-gradient(90deg, rgb(${pr.rgb} / 0.38), rgb(${pr.rgb} / 0.08))`);
  set('--sb-active-glow', `0 0 0 1px rgb(${pr.rgb} / 0.28), 0 6px 18px rgb(${pr.rgb} / 0.28)`);
  set('--sb-active-bar', `linear-gradient(180deg, ${pr.light}, ${pr.main})`);
  set('--bar-line', `linear-gradient(90deg, ${[...p.bar, p.bar[0]].join(', ')})`);
  set('--auth-bg', `linear-gradient(120deg, ${p.auth[0]}, ${p.auth[1]}, ${p.auth[2]}, ${p.auth[0]})`);
  p.authBlobs.forEach((c, i) => set(`--auth-blob-${i + 1}`, c));
  p.nav.forEach((c, i) => set(`--nav-${i + 1}`, c));
  set('--link-on-dark', pr.light);
}
